LS.util.route({
	'$root': {
		':load': 'home',
		':unload': 'home:unload'
	}
});